const SueloCard = ({ value }) => {

  return (
    <>
      <th scope="row">{value.idNodo}</th>
      <td>{value.lat}</td>
      <td>{value.lon}</td>
      <td>{value.temperatura}</td>
      <td>{value.humedad}</td>
      <td>{value.salinidad}</td>
      <td>{value.conductividad}</td>
      <td>{value.humedadAire}</td>
      <td>{value.fecha}</td>
      <td>{value.hora}</td>
    </>
  )

}

export default SueloCard